import UniversalPortal from './UniversalPortal';
import { appendUniversalPortals, prepareClientPortals } from './helpers';

export const PORTAL_ITEM_NAME = 'data-react-universal-portal';

export const portals: string[] = [];

export { UniversalPortal, appendUniversalPortals, prepareClientPortals };
